import IconButton from 'apollo-react/components/IconButton';
import MenuItem from 'apollo-react/components/MenuItem';
import Select from 'apollo-react/components/Select';
import Tooltip from 'apollo-react/components/Tooltip';
import FolderOpenIcon from 'apollo-react-icons/FolderOpen';
import React from 'react';

import { getDomainUrl } from '../../../../../utils/qs';
import {
  RELATIONS_CHILD_ENTITY_NAME,
  RESOLVED_FIELDS_TARGET_ITEMS,
} from '../../../../constants/entity-designer.constants';
import {
  getIsRequired,
  getIsViewOnly,
  getViewOnlyValue,
} from '../../../../utils/entity-designer.utils';

const linkToRelatedEntity = ({ row, key }) => {
  const entityName = row[key];

  const handleClick = () => {
    window.open(`${getDomainUrl()}/entity-editor?entityName=${entityName}&standaloneLayout=true`);
  };

  return (
    entityName && (
      <Tooltip title={row?.translateString('View Related Entity')}>
        <IconButton style={{ marginTop: 10 }} onClick={handleClick}>
          <FolderOpenIcon size="small" />
        </IconButton>
      </Tooltip>
    )
  );
};
const EditableSelectCell = (listName) => ({ row, column: { accessor: key } }) => {
  const viewOnly = getIsViewOnly({ key, row });
  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);
  const required = getIsRequired({ key, row });

  const onChange = ({ target }) => {
    if (row[key] === target.value) {
      return;
    }

    row.editRow({ rowId: row.rowId, key, value: target.value, error });
  };

  const isTargetItemsList = listName === RESOLVED_FIELDS_TARGET_ITEMS;

  return row.isEditMode && !viewOnly ? (
    <div className={row?.classes?.childEntityWrapper}>
      <Select
        size="small"
        fullWidth
        asteriskPosition="before"
        value={row[key]}
        required={required}
        onChange={onChange}
        error={!!error}
      >
        {row[listName]?.map((option, index) => (
          <MenuItem key={option.value + index} value={option.value}>
            {isTargetItemsList
              ? `${row.translateString(option.label)} (${option.columnName}) `
              : option.label}
          </MenuItem>
        ))}
      </Select>
      {key === RELATIONS_CHILD_ENTITY_NAME && linkToRelatedEntity({ row, key })}
    </div>
  ) : (
    getViewOnlyValue({ listItems: row[listName], row, key })
  );
};

export default EditableSelectCell;
